import { render, staticRenderFns } from "./WidgetInfo.vue?vue&type=template&id=ff1a7cd4"
import script from "./WidgetInfo.vue?vue&type=script&lang=js"
export * from "./WidgetInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports